'use client'

import { useState } from 'react'
import { useRouter } from '@/shared/navigation'
import {
  SWITCH_DEVICE_DIALOG,
  SWITCH_DEVICE_HINT,
  SWITCH_DEVICE_LABEL,
} from '@/features/auth/deviceSwitchCopy'

type Props = {
  activateHref: string
  onReset: () => void
  className?: string
}

export function SwitchDeviceFooter({ activateHref, onReset, className }: Props) {
  const router = useRouter()
  const [dialogOpen, setDialogOpen] = useState(false)

  function handleConfirm() {
    onReset()
    setDialogOpen(false)
    router.replace(activateHref)
  }

  return (
    <>
      <div
        className={`bg-surface-container py-4 px-gutter-tablet sm:px-gutter-desktop text-center border-t border-surface-variant space-y-2 ${className ?? ''}`}
      >
        <button
          type="button"
          onClick={() => setDialogOpen(true)}
          className="text-label-md text-primary inline-flex items-center gap-2"
        >
          <span className="material-symbols-outlined text-sm">sync_alt</span>
          {SWITCH_DEVICE_LABEL}
        </button>
        <p className="text-label-md text-on-surface-variant px-2">{SWITCH_DEVICE_HINT}</p>
      </div>

      {dialogOpen && (
        <div
          className="fixed inset-0 z-40 bg-inverse-surface/40 flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          aria-labelledby="switch-device-title"
        >
          <div className="w-full max-w-sm bg-surface-card border border-outline-variant rounded-xl shadow-sm p-4 space-y-4">
            <div>
              <p id="switch-device-title" className="text-headline-md text-primary">
                {SWITCH_DEVICE_DIALOG.title}
              </p>
              <p className="text-body-sm text-on-surface-variant mt-2 whitespace-pre-line">
                {SWITCH_DEVICE_DIALOG.message}
              </p>
            </div>
            <div className="flex gap-2">
              <button
                type="button"
                className="btn-outline flex-1 min-h-[44px]"
                onClick={() => setDialogOpen(false)}
              >
                {SWITCH_DEVICE_DIALOG.cancel}
              </button>
              <button type="button" className="btn-danger flex-1" onClick={handleConfirm}>
                {SWITCH_DEVICE_DIALOG.confirm}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
